export const AUTH_PROVIDER_KEY = 'authProvider';
export const AUTH_PROVIDER_LEGACY = 'legacy';
export const AUTH_PROVIDER_MOS = 'mos';

export const MOS_RETURN_URL_STORAGE_KEY = 'mosReturnUrl';
/** After 401 local clear, next Login with MOS must end MOS SSO before authorize. */
export const MOS_FORCE_REAUTH_STORAGE_KEY = 'mosForceReauth';
/** id_token_hint preserved across local clear for the forced end-session redirect. */
export const MOS_ID_TOKEN_HINT_STORAGE_KEY = 'mosIdTokenHintForReauth';
/** MosLogout should start a fresh MOS login after end-session (SSO cookies cleared). */
export const MOS_START_LOGIN_AFTER_LOGOUT_KEY = 'mosStartLoginAfterLogout';

// Paths aligned with the MOS InPulse SPA client registration (RedirectUris / PostLogoutRedirectUris).
export const MOS_CALLBACK_PATH = '/auth/mapal-os/callback';
export const MOS_COMPLETE_PATH = '/auth/mapal-os/complete';
export const MOS_ENTRY_PATH = '/auth/mapal-os';
export const MOS_LOGOUT_PATH = '/auth/mapal-os/logged-out';

export const isMosOidcBootstrapPath = (pathname = window.location.pathname) =>
  pathname === MOS_CALLBACK_PATH || pathname === MOS_COMPLETE_PATH;
